import { useTranslation } from "react-i18next";
import type { BlobItem as BlobItemType } from "@azure/storage-blob";
import { BlobStore } from "@/stores/BlobStore";
import { Eye, Trash2 } from "lucide-react";

interface BlobActionsProps {
  blob: BlobItemType;
  onView?: (blob: BlobItemType) => void;
}

export function BlobActions({ blob, onView }: BlobActionsProps) {
  const { t } = useTranslation();
  const openDeleteConfirmation = BlobStore(state => state.openDeleteConfirmation);

  const handleView = () => {
    onView?.(blob);
  };

  const handleDeleteClick = () => {
    openDeleteConfirmation(blob);
  };

  return (
    <div className="flex-shrink-0 flex items-center space-x-2">
      <button
        onClick={handleView}
        title={t("knowledgeBase.view")}
        className="p-2 text-primary hover:opacity-80 hover:bg-gray-100 rounded-md transition-colors"
      >
        <Eye size={16} />
      </button>
      <button
        onClick={handleDeleteClick}
        title={t("knowledgeBase.delete")}
        className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-md transition-colors"
      >
        <Trash2 size={16} />
      </button>
    </div>
  );
}
